// extracted by mini-css-extract-plugin
module.exports = {"detail-header-wrapper":"styles_detail-header-wrapper__cKrAK","detail-header":"styles_detail-header__sMAZ5"};